import React from "react";
import Footer from "../components/Footer";

import Navbaartesting from "../components/Navbaartesting";
import Slide from "../school_images/slide-4.jpg";
import { FaFacebook } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoLinkedin } from "react-icons/io5";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Academic = () => {
  return (
    <div>
      <Navbaartesting />
      <MainImageDiv>
        <img src={Slide} alt="Career_image" className="w-full" />
        <SocialMediaIconsDiv>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.facebook.com/gdgoenkadarbhanga/"
              target="_blank"
            >
              <FaFacebook />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.youtube.com/channel/UCyG9n-Bbb75mEgQ5FWLtggg"
              target="_blank"
            >
              <IoLogoYoutube />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.instagram.com/gdgoenkadarbhanga"
              target="_blank"
            >
              <FaInstagramSquare />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3 ">
            <Link
              to="https://www.linkedin.com/in/gd-goenka-darbhanga-b88430217"
              target="_blank"
            >
              <IoLogoLinkedin />
            </Link>
          </div>
        </SocialMediaIconsDiv>
        <MainHeading className=" font-bold pt-10 px-10 uppercase  absolute ">
          Academic
        </MainHeading>
      </MainImageDiv>
      <AcademicContainer>
        <p>
          The aim of education at G D Goenka Public School, Darbhanga is to help
          students acquire the means to think for themselves anf put their
          knowledge to positive use.
        </p>
        <p>
          With academic constituting a major part of School life, GDGPS
          Darbhanga employs innovative Pedagogical Practices comprising of state
          of the art facilities, highly involves faculty and creative approach
          to the curriculum to make the process of academic proficiency an
          intresting and engaging period for students. This produces two
          distinctive results. First, children learn better, understand better
          and retain better; Second, an intrinsic desire to learn is aroused
          that stays with them for life.
        </p>
        <p>
          Every kind of finds motivation and every learner becomes an intrinsic
          Learner. GDGPS Darbhanga keeps the traditional competence of the
          Indian Education System intact while enabling each child to lap
          his/her highest potential.{" "}
        </p>
        <ImageTextDiv>
          <TextDiv>
            <h2>curriculum Mapping</h2>
            <p>
              Is an exhaustive and innovative process of mapping the entire year
              curriculum, to determine the most effective pedagogical practice
              for each unit / concept. Clarity of objective ensures wholehearted
              participation of children. This innovative pedagogical practice
              aligns children with their own education process. Classroom
              learning becomes more involved and interesting.
            </p>
            <h2>MINIMUM LEARNING PROGRAMME - MLP</h2>
            <p>
              {" "}
              What is the minimum learning expected out of a child from a
              particular unit / concept? Every section of the unit is condensed
              into MLP notes that contain a summary of the entire unit and its
              interrelation with the other units. This intensive and innovative
              practice not only works as an excellent time saver for students
              but gives them a comprehensive understanding of the concept at a
              glance.
            </p>
          </TextDiv>
          <ImageDiv>
            <img src={Slide} alt="jkdfjks" />
          </ImageDiv>
        </ImageTextDiv>
        <ImageTextDiv>
          <ImageDiv>
            <img src={Slide} alt="dskjfskj" />
          </ImageDiv>
          <TextDiv>
            <h2>SUBJECT NARRATIONS</h2>
            <p>
              Innovation in pedagogy is taken to the level of excellence through
              subject narrations, which is based on the premise that teaching
              learning process must not be a suspense unfolding every day but an
              informed process. Students are given an overview of the entire
              syllabus, the teaching methodology, the system & pattern of
              evaluation and timeline. Students come to class fully prepared,
              absorbing and analyzing completely. Class room learning becomes
              more involved and interesting.
            </p>
            <p>
              This practice is followed in the Co Scholastic and Sports domain
              as well, giving students a glimpse of the way each respective unit
              will unfold during the course of the session.
            </p>
          </TextDiv>
        </ImageTextDiv>
        <ImageTextDiv>
          <TextDiv>
            <h2>LEARNERS' ENRICHMENT FOR ACADEMIC PROGRESSION - LEAP</h2>
            <p>
              LEAP is a comprehensive student centric plan for the second phase
              of Online Teaching-Learning, implemented as Virtual Engagement 2.0
              with three important components-
            </p>
            <p>
              Step 1: Asynchronous material sent to our learners, including an
              interactive PPT/ Audio/Video before initiating a topic to get them
              familiar with the concept in advance before it is taken up as an
              active lesson.
            </p>
            <p>
              Step 2: Synchronous learning wherein all the learners come
              together at a specific time period for lesson presentation. This
              makes it easier for the learner to grasp the concept and the
              teacher gets a base to build on.
            </p>
          </TextDiv>
          <ImageDiv>
            <img src={Slide} alt="nfl" />
          </ImageDiv>
        </ImageTextDiv>
        <p>
          Step 3: The learners are further aided in smaller groups based on
          their pace of learning by the teacher who acts as the facilitator in
          joining the dots to complete the picture with application based and
          Higher Order Thinking Skill activities.
        </p>
        <ImageGallery></ImageGallery>
        <ImageTextDiv>
          <ImageDiv>
            <img src={Slide} alt="ghfhh" />
          </ImageDiv>
          <TextDiv>
            <h2>INTEGRATED CREATIVE LEARNING PROGRAMME - ICLP</h2>
            <p>
              ICLP - Integrated Creative Learning Programme integrates the
              Scholastic with the Co scholastic and makes the learning of
              Science, Mathematics and Literature more pertinent,
              application-based and effective through an integration of the two
              domains.
            </p>
            <p>
              In ICLP different co scholastic and scholastic subjects are learnt
              together in smaller groups:
            </p>

            <div>
              <div className="flex space-x-4  justify-start items-center">
                <span className="w-[15px] h-[15px] border bg-red-400 rounded"></span>
                <p style={{ marginBottom: 0 }}>
                  LEGEND - Literature Maths Music and Dance
                </p>
              </div>
              <div className="flex space-x-4  justify-start items-center">
                <span className="w-[15px] h-[15px] border bg-blue-400 rounded"></span>
                <p style={{ marginBottom: 0 }}>
                  SCITECH - Science and technology
                </p>
              </div>
              <div className="flex space-x-4  justify-start items-center">
                <span className="w-[15px] h-[15px] border bg-green-400 rounded"></span>
                <p style={{ marginBottom: 0 }}>
                  MMS - Maths, Music and Science
                </p>
              </div>
              <div className="flex space-x-4  justify-start items-center">
                <span className="w-[15px] h-[15px] border bg-orange-400 rounded"></span>
                <p style={{ marginBottom: 0 }}>
                  TESLA - Theatre Literature and Science
                </p>
              </div>
              <div className="flex space-x-4  justify-start items-center">
                <span className="w-[15px] h-[15px] border bg-orange-400 rounded"></span>
                <p style={{ marginBottom: 0 }}>
                  SMART - Science, Maths and Art
                </p>
              </div>
            </div>
          </TextDiv>
        </ImageTextDiv>
        <ImageTextDiv>
          <TextDiv>
            <h2>ART INTEGRATED LEARNING - AIL</h2>
            <p>
              School believes in adding many inventive dimensions and layers to
              the most basic and ordinary learning, thus metamorphosising it
              into an extraordinary and unforgettable process. The innovative
              pedagogical practices are simplistic in nature, yet have a lot of
              scope to be implemented in any system.
            </p>
          </TextDiv>
          <ImageDiv>
            <img src={Slide} alt="sdfs" />
          </ImageDiv>
        </ImageTextDiv>
      </AcademicContainer>

      <Footer />
    </div>
  );
};

export default Academic;

const ImageGallery = styled.div`
  height: 400px;
  width: 100%;
`;

const AcademicContainer = styled.div`
  padding: 0% 7%;
  text-align: left;
  p {
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 300;
    @media (max-width: 500px) {
      font-size: 16px;
    }
  }
  h2 {
    font-weight: 500;
    font-size: 40px;
    @media (max-width: 500px) {
      font-size: 20px;
    }
  }
  h1 {
    font-size: 50px;
    text-transform: uppercase;
    text-decoration: underline;
    margin-bottom: 1rem;
    font-weight: 600;
    @media (max-width: 500px) {
      font-size: 30px;
    }
  }
`;

const MainHeading = styled.span`
  position: absolute;
  bottom: 10%;
  right: 10%;
  color: #2c975b;
  font-size: 50px;
`;

const MainImageDiv = styled.div`
  padding: 0 0%;
  max-height: 500px;
  min-height: 330px;
  position: relative;
  img {
    max-height: 500px;
    height: 100%;
    width: 100%;
    min-height: 330px;
  }
`;

const SocialMediaIconsDiv = styled.span`
  color: #fff;
  position: absolute;
  top: 20%;
  right: 2%;
  a {
    color: #fff;
    font-size: 30px;
    &:hover {
      color: brown;
    }
  }
  div {
    @media (max-width: 640px) {
      font-size: 25px;
      width: 45px;
      height: 45px;
    }
  }
`;

const ImageTextDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;

  @media (max-width: 700px) {
    flex-direction: column;
  }
  p {
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
    @media (max-width: 500px) {
      font-size: 16px;
    }
  }
`;

const ImageDiv = styled.div`
  width: 50%;
  height: auto;
  min-height: 300px;
  @media (max-width: 700px) {
    width: 100%;
  }
`;

const TextDiv = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  text-align: left;
  @media (max-width: 700px) {
    width: 100%;
  }
  p {
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
    @media (max-width: 500px) {
      font-size: 16px;
    }
  }
`;
